module.exports = {
  env: {
    API_BASE_URL:'https://confess-api.adpl.it',
    STORAGE_URL: 'https://confess-api.adpl.it/uploads/',
  },
}
